import { openComposer } from "react-native-email-link";
import { isAndroid, isWeb } from "./platform";

export const composeMessage = (
	subject: string,
	body: string,
	supportEmail: string,
) => {
	if (isWeb) {
		const mailtoLink = `mailto:${supportEmail}?subject=${encodeURIComponent(
			subject,
		)}&body=${encodeURIComponent(body)}`;
		window.location.href = mailtoLink;
	} else {
		openComposer({
			to: isAndroid ? supportEmail : encodeURIComponent(supportEmail),
			subject: isAndroid ? subject : encodeURIComponent(subject),
			body: isAndroid ? body : encodeURIComponent(body),
		});
	}
};
